import { Box, Typography } from "@mui/material";
import IntakeHeaderBackButton from "../intake/IntakeHeaderBackButton";
import {
  STICKY_PAGE_HEADER_OUTER_ROW_SX,
  STICKY_PAGE_HEADER_SUBTITLE_SX,
  STICKY_PAGE_HEADER_TEXT_COLUMN_SX,
  PAGE_HEADER_TITLE_SX,
} from "./stickyPageHeaderTokens";

/**
 * Back-arrow placement — same 24px / 16px ink standard as Gate 0 and Gate 1
 * headers. CSS backs out the 6px hit-target inset and Lato's ~1px capital
 * side bearing. Other header gaps stay 8px.
 */
const BACK_ARROW_INK_LEFT_PX = 24;
const BACK_ARROW_INK_GAP_RIGHT_PX = 16;
const BACK_ARROW_HIT_TARGET_INSET_PX = 6;
const TITLE_LEFT_SIDE_BEARING_PX = 1;
const HEADER_INSET_LEFT_PX = BACK_ARROW_INK_LEFT_PX - BACK_ARROW_HIT_TARGET_INSET_PX;
const BACK_ARROW_GAP_RIGHT_PX =
  BACK_ARROW_INK_GAP_RIGHT_PX - BACK_ARROW_HIT_TARGET_INSET_PX - TITLE_LEFT_SIDE_BEARING_PX;
const HEADER_ROW_GAP_PX = 8;
const TITLE_NUDGE_LEFT_PX = BACK_ARROW_GAP_RIGHT_PX - HEADER_ROW_GAP_PX;

/**
 * Page header with back control — subtitle aligns with the title’s first letter (shared text column).
 */
export default function StickyPageHeaderWithBack({
  title,
  subtitle,
  onBack,
  backAriaLabel = "Back",
  headerSx,
  children,
}) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        boxSizing: "border-box",
        width: "100%",
        pl: `${HEADER_INSET_LEFT_PX}px`,
        pr: { xs: 2, md: 3 },
        py: "16px",
        bgcolor: "#FFFFFF",
        borderBottom: "1px solid #E6E6E6",
        ...headerSx,
      }}
    >
      <Box
        sx={{
          ...STICKY_PAGE_HEADER_OUTER_ROW_SX,
          gap: `${HEADER_ROW_GAP_PX}px`,
        }}
      >
        <IntakeHeaderBackButton onClick={onBack} aria-label={backAriaLabel} />
        <Box sx={{ ...STICKY_PAGE_HEADER_TEXT_COLUMN_SX, ml: `${TITLE_NUDGE_LEFT_PX}px` }}>
          <Typography component="h1" sx={PAGE_HEADER_TITLE_SX}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography component="p" sx={STICKY_PAGE_HEADER_SUBTITLE_SX}>
              {subtitle}
            </Typography>
          ) : null}
          {children}
        </Box>
      </Box>
    </Box>
  );
}
